{
  "name": "@ns/support-trust-score-review",
  "version": "1.0.0",
  "description": "A company's trust score waits for review: nodeStream support checks it and publishes or suppresses it through trust-score/publish and trust-score/suppress",
  "inputs": {
    "subjectCompanyId": {
      "type": "string"
    },
    "subjectCompanyName": {
      "type": "string"
    }
  },
  "outcomes": {
    "published": {},
    "suppressed": {},
    "closed": {}
  }
}
